<template>
  <div class="train-project">
    <div class="train-project-title">{{ $t('trainProject.title') }}</div>
    <div class="table-center">
      <div class="table-body">
        <el-table :data="projectList" :border="true" height="100%">
        <el-table-column type="index" :label="$t('common.serialNo')" width="50" :fixed="true"></el-table-column>
        <el-table-column prop="nameCh" :label="$t('common.project')" width="200" :fixed="true">
          <template slot-scope="scope">
            {{localeValue(scope.row, projectNameKey)}}
          </template>
        </el-table-column>
        <el-table-column prop="trainAthleteList" :label="$t('common.athlete')">
          <template slot-scope="scope">
            <span v-for="(item, index) in scope.row.trainAthleteList" :key="item.id" style="width: 100%">
              <span v-if="index === 0">{{localeValue(item, competitionAthleteNameKey)}}</span>
              <span v-else>、{{localeValue(item, competitionAthleteNameKey)}}</span>
              <span v-if="item.practice === 1">（{{ $t('common.trainingPartner') }}）</span>
            </span>
          </template>
          <template slot-scope="scope">
            <div v-for="(trainValue, trainKey, index) in scope.row.trainAthleteList" :key="trainKey">
              {{index+1}}、
              <span v-for="(trainItem, index) in trainValue" :key="trainItem.id" style="width: 100%">
                <span v-if="index === 0">{{localeValue(trainItem, competitionAthleteNameKey)}}</span>
                <span v-else>、{{localeValue(trainItem, competitionAthleteNameKey)}}</span>
                <span v-if="trainItem.practice === 1">（{{ $t('common.trainingPartner') }}）</span>
              </span>
              <span v-if="trainValue[0] && trainValue[0].description">（{{ remarkLabel }}：{{trainValue[0].description }}）</span>
              <el-button style="margin-left: 30px" @click="handleEditAthlete(scope.row.id, scope.row.competitionGroupId, trainKey, 2, scope.row.participantGroupIds)" type="text" :disabled="isTeamSubmitted">{{ $t('common.edit') }}</el-button>
              <el-button style="margin-left: 30px; color:#F56C6C;" @click="handleDeleteAthlete(scope.row.id, trainKey)" type="text" :disabled="isTeamSubmitted">{{ $t('common.delete') }}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('common.operation')" width="100">
          <template slot-scope="scope">
            <el-button @click="handleEditAthlete(scope.row.id, scope.row.competitionGroupId, '', 1, scope.row.participantGroupIds)" type="text" :disabled="isTeamSubmitted">{{ $t('trainProject.editProject') }}</el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>
    </div>

    <!--  编辑报项  -->
    <el-dialog :title="$t('trainProject.editProject')" :visible.sync="athleteFormVisible" width="700px"
               lock-scroll :close-on-click-modal="false">
      <el-form ref="athleteDataForm" :model="athleteDataForm" :rules="athleteRuleForm" v-loading="athleteFormLoading" label-width="200px">
        <el-form-item :label="$t('common.athlete')">
            <div class="athlete-checked" v-for="item in athleteList" :key="item.id">
              <el-checkbox :label="item.id" v-model="item.athleteCheck">{{localeValue(item, athleteNameKey)}}</el-checkbox>
              <el-checkbox :label="item.id" v-model="item.practiceCheck" v-if="item.athleteCheck">{{ $t('common.trainingPartner') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item v-if="remarkRequired" :label="remarkLabel" prop="description"
                      :rules="[{required: true, message: remarkPlaceholder, trigger: 'blur'}]">
          <el-input v-model="athleteDataForm.description" type="textarea" :placeholder="$t('common.pleaseInput')"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="athleteFormVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" :loading="athleteBtnLoading" @click="handleEditAthleteSubmit()">{{ $t('common.ok') }}</el-button>
    </span>
    </el-dialog>
  </div>
</template>
<script>
import {getAthleteListTrainProject} from "@/api/athlete";
import {listTrainProject} from "@/api/competitionProject";
import {listTrainByProjectId, saveTrainProject, deleteTrainGroup} from "@/api/athleteProject";
export default {
  name: "train-project",
  props: {
    teamInfo: {
      type: Object,
      required: true
    },
    competitionFormConfigInfo: {
      type: Object,
      default: function () {
        return {
          id: '',
          competitionId: '',
          teamForm: {},
          athleteForm: {},
          personForm: {},
          projectForm: {},
          summaryForm: {}
        }
      }
    }
  },
  computed: {
    // 备注标题（报项表单配置，留空默认备注）
    remarkLabel() {
      const remarkLabel = (this.competitionFormConfigInfo.projectForm || {}).remarkLabel;
      return remarkLabel || this.$t('common.comment');
    },
    // 备注输入提示
    remarkPlaceholder() {
      return this.$t('common.pleaseInput') + this.remarkLabel;
    },
    // 项目名称中英文
    projectNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 运动员姓名中英文
    athleteNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'realNameCh' : 'realNameEn';
    },
    // 赛事运动员姓名中英文
    competitionAthleteNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'athleteRealNameCh' : 'athleteRealNameEn';
    },
    // 当前项目
    currentProject() {
      return this.projectList.find(item => item.id === this.athleteDataForm.projectId);
    },
    // 项目是否要求填写备注（要求时备注必填）
    remarkRequired() {
      return !!(this.currentProject && this.currentProject.isRemark === 1);
    },
  },
  data() {
    return {
      // 项目列表
      projectList: [],
      // 编辑运动员表单
      athleteFormVisible: false,
      // 编辑运动员表单加载loading
      athleteFormLoading: false,
      // 编辑运动员表单确定loading
      athleteBtnLoading: false,
      // 编辑运动员表单
      athleteDataForm: {
        projectId: '',
        addOrEdit: '',
        trainGroup: '',
        description: ''
      },
      // 运动员列表
      athleteList: [],
      athleteRuleForm: {
        athleteCheck: [
          {required: true, message: this.$t('validate.requiredSelect'), trigger: 'blur'},
        ],
      }
    };
  },
  created() {
    let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.competitionId = id;
    }
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login?id=" + this.competitionId });
    } else {
      this.findProjectList();
    }
  },
  destroyed() {},
  methods: {
    // 项目列表
    findProjectList(){
      let params = {
        competitionId: this.competitionId,
        projectType: 3
      }
      listTrainProject(params).then((res) => {
        if (res.code === 200) {
          this.projectList = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 运动员列表（优先按项目可参赛组别集合查询，未配置时按项目所属组别）
    findAthleteList(groupId, participantGroupIds){
      this.athleteList = [];
      let params = {
        competitionId: this.competitionId
      }
      const groupIds = participantGroupIds ? String(participantGroupIds).split(',').map(Number).filter(id => !isNaN(id)) : [];
      if (groupIds.length > 0) {
        // 逗号分隔字符串传递，避免 axios 数组默认序列化成 groupIds[]= 导致后端绑定报错
        params.groupIds = groupIds.join(',');
      } else if (groupId) {
        params.groupId = groupId;
      }
      return getAthleteListTrainProject(params).then((res) => {
        if (res.code === 200) {
          let athleteList = res.data.list;
          if (athleteList.length > 0) {
            let newAthleteList = [];
            for (let i = 0; i < athleteList.length; i++) {
              let athleteObj = athleteList[i];
              newAthleteList.push({
                id: athleteObj.id,
                realNameCh: athleteObj.realNameCh,
                realNameEn: athleteObj.realNameEn,
                sortCode: athleteObj.sortCode,
                athleteCheck: false,
                practiceCheck: false
              })
            }
            this.athleteList = newAthleteList;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 编辑报项表单
    async handleEditAthlete(id, groupId, trainGroup, addOrEdit, participantGroupIds){
      this.athleteDataForm.projectId = id || '';
      this.athleteDataForm.trainGroup = trainGroup || '';
      this.athleteDataForm.addOrEdit = addOrEdit || '';
      this.athleteFormVisible = true;
      await this.findAthleteList(groupId, participantGroupIds);
      this.$nextTick(() => {
        this.$refs['athleteDataForm'].resetFields();
        // 防止残留上一次编辑的备注
        this.athleteDataForm.description = '';
        if (id) {
          let params = {
            competitionId: this.competitionId,
            projectId: id,
            projectType: 3,
            trainGroup: trainGroup
          }
          listTrainByProjectId(params).then((res) => {
            if (res.code === 200) {
              let trainProjectList = res.data.list;
              let athleteList = this.athleteList;
              let newAthleteList = [];
              for (let i = 0; i < athleteList.length; i++) {
                let athleteObj = athleteList[i];
                let trainProjectObj = trainProjectList.find(item => item.athleteId === athleteObj.id);
                if (trainProjectObj) {
                  athleteObj.athleteCheck = true;
                  athleteObj.practiceCheck = trainProjectObj.practice === 1;
                  this.athleteDataForm.description = trainProjectObj.description;
                }
                newAthleteList.push(athleteObj);
              }
              this.athleteList = newAthleteList;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.athleteDataForm.competitionId = this.competitionId;
        }
      })
    },
    // 编辑报项提交
    handleEditAthleteSubmit(){
      let athleteList = this.athleteList;
      let checkAthleteList = athleteList.filter(item => item.athleteCheck);
      if (!checkAthleteList || checkAthleteList.length === 0) {
        return this.$message.warning(this.$t('trainProject.needSelectAthlete'));
      }
      // 项目要求备注时必填
      if (this.remarkRequired && !(this.athleteDataForm.description || '').trim()) {
        return this.$message.warning(this.remarkPlaceholder);
      }
      let trainAthleteList = [];
      for (let i = 0; i < checkAthleteList.length; i++) {
        let athleteObj = checkAthleteList[i];
        trainAthleteList.push({
          athleteId: athleteObj.id,
          practice: athleteObj.practiceCheck ? 1 : 0,
          sortCode: this.athleteDataForm.projectId
        })
      }
      let dataForm = {
        teamId: this.teamInfo.id,
        projectId: this.athleteDataForm.projectId,
        addOrEdit:  this.athleteDataForm.addOrEdit,
        trainGroup: this.athleteDataForm.trainGroup,
        description: this.athleteDataForm.description,
        trainAthleteList: trainAthleteList
      }
      this.athleteBtnLoading = true;
      saveTrainProject(this.competitionId, dataForm).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg);
          this.findProjectList();
          this.athleteBtnLoading = false;
          this.athleteFormVisible = false;
        } else {
          this.$message.error(res.msg);
          this.athleteBtnLoading = false;
        }
      });
    },
    // 删除对练项目组
    handleDeleteAthlete(projectId, trainGroup){
      this.$confirm(this.$t('trainProject.deleteConfirm'), this.$t('common.prompt'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning",
      }).then(() => {
        let params = {
          competitionId: this.competitionId,
          projectId: projectId,
          trainGroup: trainGroup
        }
        deleteTrainGroup(params).then(res => {
          if (res.code === 200) {
            this.$message.success(res.msg);
            this.findProjectList();
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
      });
    }
  },
};
</script>
<style scoped lang="scss">
.train-project{
  width: 100%;

  .train-project-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    padding-bottom: 12px;
    margin-bottom: 20px;
    border-bottom: 2px solid #1E50AE;
  }

  .table-center {
    height: calc(100vh - 300px);
    margin-top: 10px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    padding: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;

    .table-body {
      flex: 1;
      height: 0;
      min-height: 0;
      overflow: hidden;

      ::v-deep .el-table {
        height: 100%;
      }
    }
  }

  ::v-deep .el-table th {
    background-color: #f0f2f5;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }

  ::v-deep .el-table .el-table__row:hover > td {
    background-color: #ecf5ff;
  }
}
</style>
